"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ladda_directive_1 = require("./ladda.directive");
var ladda_config_1 = require("./ladda-config");
var LaddaModule = (function () {
    function LaddaModule() {
    }
    LaddaModule.forRoot = function (config) {
        return {
            ngModule: LaddaModule,
            providers: [
                { provide: ladda_config_1.LaddaConfig, useValue: config }
            ]
        };
    };
    return LaddaModule;
}());
LaddaModule.decorators = [
    { type: core_1.NgModule, args: [{
                declarations: [ladda_directive_1.LaddaDirective],
                exports: [ladda_directive_1.LaddaDirective],
            },] },
];
/** @nocollapse */
LaddaModule.ctorParameters = function () { return []; };
exports.LaddaModule = LaddaModule;
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/angular2-ladda/module/module.js
// module id = ../../../../angular2-ladda/module/module.js
// module chunks = 8